const item = (sku, description, quantity) => ({ sku, description, quantity });

export const sugarcane = [
  {
    slug: "sugarcane-plates-and-bowls", name: "Sugarcane Plates & Bowls", category: "sugarcane",
    description: "Environmentally friendly, compostable sugarcane plates and bowls.",
    items: [item("7SCP", '7" plates', 1000, 45), item("9SCP", '9" plates', 500, 40), item("10SCP", '10" plates', 500, 50), item("1210SCP", '12"x10" oval plates', 500, 75), item("12ozSCB", "12 oz bowls", 1000, 60), item("16ozSCB", "16 oz bowls", 600, 45)],
  },
  {
    slug: "sugarcane-hinged-containers", name: "Sugarcane Hinged Containers", category: "sugarcane",
    description: "Environmentally friendly, compostable sugarcane hinged takeout containers.",
    items: [item("SC61", '6"x6"', 200, 20), item("SC96", '9"x6"', 200, 30), item("SC91", '9"x9"', 200, 40)],
  },
];
